export const getApiUrl = () => {
  if (process.env.NODE_ENV === "development") {
    return "http://localhost:3001";
  }
  return "https://dipe-chain-api-bf9e112f1ffc.herokuapp.com";
};
